import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import basketSelector from 'selectors/basket/basketSelector';
import rewardsSelector from 'selectors/rewards/rewardsSelector';
import RwdBasketActions from 'actions/RwdBasketActions/RwdBasketActions';
import skuUtils from 'utils/Sku';
import productSamplesActions from 'actions/ProductSamplesActions';
import BIRewardsActions from '../../../actions/BIRBActions';
import BasketUserDataSelector from 'selectors/page/rwdBasket/basketUserDataSelector';
import modalsSelector from 'selectors/modals/modalsSelector';
import { setFromBazaar } from 'actions/RewardBazaarActions';
import { rewardFulfillmentSelector } from '../../../selectors/rewardFulfillment/rewardFulfillmentSelector';

const { openBiRewardsModal } = RwdBasketActions;
const { fetchBiRewards } = BIRewardsActions;
const { basketUserDataSelector } = BasketUserDataSelector;
const { showErrorMessage } = productSamplesActions;

const { wrapHOC } = FrameworkUtils;

const fields = createSelector(
    rewardsSelector,
    basketUserDataSelector,
    basketSelector,
    modalsSelector,
    rewardFulfillmentSelector,
    (availableRewards, user, basket, modals, rewardFulfillment) => {
        const samples = basket?.items?.filter(item => skuUtils.isBiReward(item.sku)) || [];
        const filteredSamples = skuUtils.getFilteredSamples(samples);
        const numberOfSamplesInBasket = filteredSamples?.length;

        return {
            availableRewards,
            biAccount: {
                biPoints: basket.netBeautyBankPointsAvailable,
                biStatus: user.biStatus,
                birthdayRewardDaysLeft: user.birthdayRewardDaysLeft
            },
            showRewardFulfillmentMethodModal: rewardFulfillment.showRewardFulfillmentMethodModal,
            basket,
            numberOfSamplesInBasket,
            argumentsObj: modals.argumentsObj
        };
    }
);

const functions = { fetchBiRewards, openBiRewardsModal, showErrorMessage, setFromBazaar };
const withBiRewardsModalProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withBiRewardsModalProps
};
